<!--应用市场-->
<template class="market">
  <div style="font-family: Alibaba">
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="marke_talive" :is='components.tail'></component>
        </keep-alive>
      </div>
      <!--导航图-->
      <div>
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in applicationList' :key='item.id'>
            <div @click='jump(item)'>
              <el-image
                style="width: 100%;height: 25vw"
                v-if="item.fullPathUrl != null"
                :src="item.fullPathUrl"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--方案标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>
      <!--方案内容-->
      <div class="box-width market" >
        <el-image
          :fit='fit'
          v-if="productIntroduction.fullPathUrl != null"
          :src="productIntroduction.fullPathUrl"
        />
        <div class="market_div">
          <h5>{{ productIntroduction.title }} <i class="el-icon-caret-right"></i><i class="el-icon-caret-right"></i><i class="el-icon-caret-right"></i></h5>
          <div v-html="productIntroduction.content" class="htmlImgSize"></div>
        </div>
      </div>

      <!--方案优势标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameTwo }}
          </h1>
          <p>{{ enNameTwo }}</p>
        </div>
      </div>
      <!--方案优势-->
      <el-row :gutter="20" class="box-width introduce">
        <el-col :lg="8" :md="8" :sm="12" :xs="24" v-for="(item, index) in solutionAdvantages" class="image-container" :key="item.id">
          <el-card>
            <div class="plan_title">
              <h1>{{ index + 1 }}</h1>
              <h2>{{ item.briefIntroduction }}</h2>
            </div>
            <!--鼠标移入显示-->
            <div class="text-box">
              <div v-html="item.content" class="introduceSize"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!--应用场景标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameThree }}
          </h1>
          <p>{{ enNameThree }}</p>
        </div>
      </div>
      <!--应用场景-->
      <el-row :span="24" class="box-width carbon" style=" background-color: #f2f2fb;" >
        <el-col :md="12" :sm="12" :xs="24">
          <div>
            <el-image  class="cases_img"
                      v-if='applicationScenarios.fullPathUrl != null'
                      :src='applicationScenarios.fullPathUrl'
            ></el-image>
          </div>
        </el-col>
        <el-col :md="12" :sm="12" :xs="24">
          <div v-html="applicationScenarios.content" style="padding: 20px"></div>
        </el-col>
      </el-row>

      <!--应用案例标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameFour }}
          </h1>
          <p>{{ enNameFour }}</p>
        </div>
      </div>
      <!--应用案例-->
      <div>
        <div class="box-width">
          <el-carousel height="360px">
            <el-carousel-item v-for="item in applicationCases" :key="item.id">
              <el-row >
                <el-col :md="12" :sm="12" :xs="24">
                  <div class="cases_text">
                    <h3>{{ item.title }}</h3>
                    <div v-html="item.content" class="htmlImgSize"></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="12" :xs="24">
                  <el-image
                    class="cases_img"
                    alt="Image Description"
                    v-if="item.fullPathUrl != null"
                    :src="item.fullPathUrl"></el-image>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="200px" class='carousel_class'>
            <el-carousel-item v-for='item in applicationList' :key='item.id'>
              <div>
                <el-image
                  :fit='fit'
                  v-if="item.fullPathUrl != null"
                  :src="item.fullPathUrl"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--智慧社区-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameOne }}
                <span>{{ enNameOne }}</span>
              </h1>
            </div>
            <!--图片-->
            <div class="plan_img">
              <el-image  v-if="productIntroduction.fullPathUrl != null"
                         :src="productIntroduction.fullPathUrl"></el-image>

            </div>
            <!--内容-->
            <div>
              <h6> <i class="el-icon-position"></i>
                {{ productIntroduction.title }}
              </h6>
              <div v-html="productIntroduction.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--方案优势-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameTwo }}
                <span>{{ enNameTwo }}</span>
              </h1>
            </div>
            <!--内容-->
            <el-row :gutter="20">
              <el-col v-for="(item, index) in solutionAdvantages" :key="item.id" class="col_color" :lg="8" :md="8" :sm="12" :xs="12">
                <h3 class="number_bColor">{{ index + 1 }}</h3>
                <span class="subtitle">
                {{ item.briefIntroduction }}
              </span>
                <div v-html="item.content" class="htmlImgSize"></div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!--应用场景-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameThree }}
                <span>{{ enNameThree }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div class="advantage_img" style="margin: 0">
                <el-image style="width: 100%"
                          v-if='applicationScenarios.fullPathUrl != null'
                          :src='applicationScenarios.fullPathUrl'
                ></el-image>
              </div>
              <div>
                <h4 style="font-size: 20px;line-height: 40px;">{{applicationScenarios.title}}</h4>
                <div v-html="applicationScenarios.content" class="htmlImgSize"></div>
              </div>
            </div>
          </div>
        </div>

        <!--应用案例-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameThree }}
                <span>{{ enNameThree }}</span>
              </h1>
            </div>
          </div>

          <div  v-for="item in applicationCases" :key="item.id">
            <div>
              <el-image style="width: 100%" v-if="item.fullPathUrl != null" :src="item.fullPathUrl"></el-image>
            </div>
            <!--内容-->
            <div>
              <h6> <i class="el-icon-position"></i>
                {{item.title }}
              </h6>
              <div v-html="item.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import {
  findBanner,
  findEnName,
  findApplicationMarketOne,
  findApplicationMarketTwo,
  findApplicationMarketThree,
  findApplicationMarketFour
} from '@/api/zh'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      activeName: 'second',
      fit: 'cover',
      src: require('@assets/images/index/fangAn.png'),
      src1: require('@assets/images/index/sb.png'),
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png'),
      applicationList: [],
      enNameOne: '',
      enNameTwo: '',
      enNameThree: '',
      enNameFour: '',
      cnNameOne: '',
      cnNameTwo: '',
      cnNameThree: '',
      cnNameFour: '',
      productIntroduction: {
        id: null,
        title: null,
        fullPathUrl: '',
        content: ''
      },
      solutionAdvantages: [],
      applicationScenarios: {
        id: null,
        title: null,
        fullPathUrl: null,
        content: ''
      },
      applicationCases: []

    }
  },
  created () {
  },
  mounted () {
    this.tabId = this.$route.query.tabId
    this.$nextTick(() => {
      this.selectBanner()
      this.selectEnName()
    })
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },

    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.applicationList = res.data
      })
    },
    /** 查询英文名称 */
    async selectEnName () {
      let that = this
      await findEnName(this.tabId).then(res => {
        let data = res.data
        that.enNameOne = data[0].enName
        that.cnNameOne = data[0].cnName
        that.selectApplicationMarketOne(data[0].id)

        that.enNameTwo = data[1].enName
        that.cnNameTwo = data[1].cnName
        that.selectApplicationMarketTwo(data[1].id)

        that.enNameThree = data[2].enName
        that.cnNameThree = data[2].cnName
        that.selectApplicationMarketThree(data[2].id)

        that.enNameFour = data[3].enName
        that.cnNameFour = data[3].cnName
        that.selectApplicationMarketFour(data[3].id)
      }).catch(error => {
        console.error('Error fetching English names:', error)
      })
    },

    selectApplicationMarketOne (enNameId) {
      let that = this
      findApplicationMarketOne(enNameId).then(res => {
        that.productIntroduction = res.data
      }).catch(error => {
        console.error('Error fetching findApplicationMarketOne:', error)
      })
    },

    selectApplicationMarketTwo (enNameId) {
      let that = this
      findApplicationMarketTwo(enNameId).then(res => {
        that.solutionAdvantages = res.data
      }).catch(error => {
        console.error('Error fetching findApplicationMarketOne:', error)
      })
    },

    selectApplicationMarketThree (enNameId) {
      let that = this
      findApplicationMarketThree(enNameId).then(res => {
        if (res != null) {
          that.applicationScenarios = res.data
        }
      }).catch(error => {
        console.error('Error fetching findApplicationMarketOne:', error)
      })
    },

    selectApplicationMarketFour (enNameId) {
      let that = this
      findApplicationMarketFour(enNameId).then(res => {
        that.applicationCases = res.data
      }).catch(error => {
        console.error('Error fetching findApplicationMarketOne:', error)
      })
    },

    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
